module.exports = __webpack_public_path__ + "img/samping kanan.b0a7da85.jpg";